// Card.tsx
import React from 'react';
import './Card.css';

interface CardProps {
    icon: JSX.Element; // Dies ermöglicht das Einbinden von beliebigen Icons, z.B. von einer Icon-Bibliothek
    title: string;
    text: string;
    color?: string;
    className?: string;
}

const Card: React.FC<CardProps> = ({ icon, title, text, color, className }) => {
    return (
        <div className={`card ${className || ''}`}>
            <div className="card-icon">{icon}</div>
            <h3 className="card-title" style= {{ color }}> {title}</h3>
            <p className="card-text">{text}</p>
        </div>
    );
};

export default Card;
